import { Action } from '@ngrx/store';

import { ReportListFilter } from '../shared/report-list-filter.model';

export const REPORT_LIST_INIT = '[REPORT LIST] - Initialize';
export const REPORT_LIST_CLEAR_FILTER = '[REPORT LIST] [FILTER] - Clear Filter';
export const REPORT_LIST_SET_FILTER = '[REPORT LIST] [FILTER] - Set Filter';
export const REPORT_LIST_SELECT_ROW = '[REPORT LIST] [GRID] - Select Row';
export const REPORT_LIST_CLEAR_SELECT_ROW = '[REPORT LIST] [GRID] - Clear Selected Row';
export const REPORT_LIST_SET_SHOWING = '[REPORT LIST] [MENU] - Change Showing Area';
export const REPORT_LIST_REQUEST_DATA = '[REPORT LIST] [GRID] - Request Data';
export const REPORT_RUN_DIALOG = '[REPORT] [PARAMS] - Show Dialog';
export const REPORT_RUN_INIT_DIALOG = '[REPORT] [RUN] - Dialog Iniitialization';
export const REPORT_RUN_SET_VERSION = '[REPORT] [RUN] - Set Version';
export const REPORT_RUN_INIT_PARAMS = '[REPORT] [RUN] - Iniitialize Report';
export const REPORT_RUN_UPDATE_PARAMS = '[REPORT] [RUN] - Update Parameters';
export const REPORT_RUN_GENERATE = '[REPORT] [RUN] - Generate Report';

export class ReportListInit implements Action {
  readonly type = REPORT_LIST_INIT;
}

export class ReportListSetFilter implements Action {
  readonly type = REPORT_LIST_SET_FILTER;
  constructor(public filter: ReportListFilter) {}
}

export class ReportListClearFilter implements Action {
  readonly type = REPORT_LIST_CLEAR_FILTER;
}

export class ReportListSetShowing implements Action {
  readonly type = REPORT_LIST_SET_SHOWING;
  constructor(public area: string) {}
}

export class ReportListSelectRow implements Action {
  readonly type = REPORT_LIST_SELECT_ROW;
  constructor(public row: any) {}
}

export class ReportListClearSelectedRow implements Action {
  readonly type = REPORT_LIST_CLEAR_SELECT_ROW;
}

export class ReportListRequestData implements Action {
  readonly type = REPORT_LIST_REQUEST_DATA;
}

export class ReportRunInitDialog implements Action {
  readonly type = REPORT_RUN_INIT_DIALOG;
  constructor(public reportName: string) {}
}

export class ReportRunSetVersion implements Action {
  readonly type = REPORT_RUN_SET_VERSION;
  constructor(public version: number) {}
}

export class ReportRunInitParams implements Action {
  readonly type = REPORT_RUN_INIT_PARAMS;
  constructor(
    public data: {
      reportName: string;
      message: string;
      params: any[];
      requestId: string;
    }
  ) {}
}

export class ReportRunUpdateParams implements Action {
  readonly type = REPORT_RUN_UPDATE_PARAMS;
  constructor(
    public data: {
      format: string;
      message: string;
      params: any[];
    }
  ) {}
}

export class ReportRunGenerate implements Action {
  readonly type = REPORT_RUN_GENERATE;
}

export type ReportActions =
  | ReportListInit
  | ReportListSetFilter
  | ReportListClearFilter
  | ReportListSetShowing
  | ReportListSelectRow
  | ReportListClearSelectedRow
  | ReportListRequestData
  | ReportRunInitDialog
  | ReportRunSetVersion
  | ReportRunInitParams
  | ReportRunGenerate
  | ReportRunUpdateParams;
